import JSEncrypt from 'jsencrypt'

/**
 * 密码加密
 * @param data
 * @param key
 * @returns
 */
export const encrypt = (data: string, key: string): string | false => {
  // 加载公钥
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(key) // 设置公钥

  return encryptor.encrypt(data)
}
